import React, { useState } from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { CronExpressionGenerator } from './CronExpressionGenerator';
export const CronJobForm: React.FC = () => {
  const [jobType] = useState<'pull'>('pull');
  const [cronExpression, setCronExpression] = useState<string>('* * * * *');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted');
    // Handle form submission logic here
  };
  return <div data-id="element-109">
      <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-110">
        Create New CRON Job
      </h2>

      <form onSubmit={handleSubmit} data-id="element-111">
        <div className="mb-6" data-id="element-112">
          <label htmlFor="jobName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-113">
            Job Name <span className="text-red-500" data-id="element-114">*</span>
          </label>
          <input type="text" id="jobName" className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Enter job name" data-id="element-115" />
        </div>

        <div className="mb-6" data-id="element-116">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-117">
            Generate Cron Expression <span className="text-red-500" data-id="element-118">*</span>
          </label>
          <CronExpressionGenerator value={cronExpression} onChange={setCronExpression} data-id="element-119" />
        </div>

        <div className="flex justify-end space-x-3" data-id="element-120">
          <button type="button" className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-121">
            Cancel
          </button>
          <button type="submit" className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-122">
            Create Cron Job
          </button>
        </div>
      </form>
    </div>;
};